import { keyframes } from '@emotion/core';

export const animationKeyframes = {
  fadeInSlideUp40: keyframes`
    0% {
        opacity: 0;
        transform: translate(0px,40px);
    }
    100% {
        opacity: 1;
        transform: translate(0px,0px);
    }
  `,

  slideLeft: keyframes`
    0% {
        transform: translate(0px,0px);
    }
    100% {
        transform: translate(-100%,0px);
    }
  `,

  slideRight: keyframes`
    0% {
        transform: translate(0px,0px);
    }
    100% {
        transform: translate(100%,0px);
    }
  `,

  fadeInSlideUp10: keyframes`
    0% {
        opacity: 0;
        transform: translate(0px,10px);
    }
    100% {
        opacity: 1;
        transform: translate(0px,0px);
    }
  `,
};
